import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=e990177a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e990177a')) {
      api.createRecord('e990177a', component.options)
    } else {
      api.reload('e990177a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=e990177a&", function () {
      api.rerender('e990177a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GPLuc6szYyT9/JS/cancellationPolicy.vue"
export default component.exports